import { render, staticRenderFns } from "./NavLogo.vue?vue&type=template&id=542a75d8&scoped=true"
var script = {}
import style0 from "./NavLogo.vue?vue&type=style&index=0&id=542a75d8&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "542a75d8",
  null
  
)

export default component.exports